export default __webpack_public_path__ + "media/react/organisms/navbars/nav_bar/assets/Magoosh_BLM_Pride_HS_400x90-99d22e4556a23d1860527fadb838294b.png";